import { cn } from "@garther/ui/libs";

export function Progress({
  className,
  value = 0,
  ...props
}: React.ComponentProps<"div"> & { value: number }) {
  return (
    <div
      data-slot="progress"
      className={cn("bg-background-highlight relative h-2 w-full overflow-hidden rounded-sm", className)}
      {...props}
    >
      <div
        data-slot="progress-indicator"
        className="bg-background-dark-secondary h-full w-full flex-1 transition-all"
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </div>
  );
}
